import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ArtworkCard({ art, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.06 }}
    >
      <Link
        to={`/archive/${art.slug}`}
        data-testid={`artwork-card-${art.slug}`}
        className="group block"
      >
        <div className="relative overflow-hidden bg-white border hairline">
          <img
            src={art.image}
            alt={art.eff_alt_text || `${art.number_label} — ${art.title}`}
            loading="lazy"
            className="art-img w-full h-auto"
          />
          <div className="absolute top-0 left-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            <span className="label" style={{ color: "var(--ink)" }}>{art.number_label}</span>
          </div>
          {art.availability === "SOLD" && (
            <div className="absolute bottom-0 right-0 p-3">
              <span className="label" style={{ color: "var(--ink)" }}>Sold</span>
            </div>
          )}
        </div>
        <div className="mt-4 flex items-baseline justify-between gap-4">
          <div>
            <div className="font-display text-sm tracking-[0.06em]">{art.number_label}</div>
            <div className="text-sm text-[var(--muted)] mt-0.5">{art.title}{art.category ? ` — ${art.category}` : ""}</div>
          </div>
          <div className="label whitespace-nowrap">{art.year}</div>
        </div>
      </Link>
    </motion.div>
  );
}
